import http from '@/utils/request'

// 获取设备告警配置分页
export const apiGetDeviceAlarmConfig = data => {
	return http.post('/monitor/water/alarm/devConfig/detail', data)
}

// 修改设备告警配置
export const apiEditDeviceAlarmConfig = data => {
	return http.post('/monitor/water/alarm/devConfig', data)
}

// 批量启停设备告警状态
export const apiBatchDeviceAlarmConfig = data => {
	return http.post('/monitor/water/alarm/batchSwitchDevConfig', data)
}

// 获取通用 / 专用告警配置列表
export const apiGetCommonAlarmConfig = data => {
	return http.post('/monitor/water/alarm/sysAlarmModel', data)
}

// 获取告警配置详情
export const apiGetAlarmConfigDetail = data => {
	return http.post('/monitor/water/alarm/sysAlarmModel/detail', data)
}

// 新增 / 修改通用告警配置
export const apiEditCommonAlarmConfig = data => {
	return http.post('/monitor/water/alarm/sysAlarmModel/config', data)
}

// 删除通用告警配置项
export const apiDeleteCommonAlarmConfig = data => {
	return http.post('/monitor/water/alarm/sysAlarmModel/deleteConfig', data)
}

// 获取专用告警配置分页
export const apiGetSpecialAlarmConfig = data => {
	return http.post('/monitor/water/alarm/specialConfig/detail', data)
}

// 删除专用告警配置项
export const apiDeleteSpecialAlarmConfig = data => {
	return http.post('/monitor/water/alarm/specialConfig/deleteConfig', data)
}

// 修改专用告警配置项
export const apiEditSpecialAlarmConfig = data => {
	return http.post('/monitor/water/alarm/specialConfig/updateConfig', data)
}

// 新增专用告警参数
export const apiCreateSpecialAlarmConfig = data => {
	return http.post('/monitor/water/alarm/specialConfig/save', data)
}

// 获取台账列表
export const apiGetLedgerList = data => {
	return http.post('/monitor/ledger/device/list', data, { needJointIsolation: true })
}

//  获取水务区域
export const apiGetWaterAreaTree = data => {
	return http.post('/monitor/water/region/waterRegionTree', data)
}
